export default "__VITE_ASSET__75b24fe4__"